// extracted by mini-css-extract-plugin
export default {"root":"header_root__yMi7s z-10 fixed top-0 left-0 bg-white w-full","content":"header_content__ieK3V h-[88px]"};